import type { ReactElement } from "react";
import { Route } from "react-router";
import * as ROUTES from "../constants/routes";
import { UnifiedCheckoutDetailsPage } from "../pages/unifiedCheckout/UnifiedCheckoutDetailsPage";
import { UnifiedCheckoutGuard } from "../pages/unifiedCheckout/UnifiedCheckoutGuard";
import { UnifiedCheckoutIndexRedirect } from "../pages/unifiedCheckout/UnifiedCheckoutIndexRedirect";
import { UnifiedCheckoutOverviewPage } from "../pages/unifiedCheckout/UnifiedCheckoutOverviewPage";
import { UnifiedCheckoutPage } from "../pages/unifiedCheckout/UnifiedCheckoutPage";
import { UnifiedCheckoutPayPage } from "../pages/unifiedCheckout/UnifiedCheckoutPayPage";
import { UnifiedCheckoutSuccessPage } from "../pages/unifiedCheckout/UnifiedCheckoutSuccessPage";

/** Checkout routes that depend on the authenticated user and current business. */
export const renderAuthenticatedCheckoutRoutes = (): ReactElement => (
  <Route
    path={ROUTES.UNIFIED_CHECKOUT_BASKET.pattern}
    element={<UnifiedCheckoutPage />}
  >
    <Route element={<UnifiedCheckoutGuard />}>
      <Route index={true} element={<UnifiedCheckoutIndexRedirect />} />
      <Route path="overview" element={<UnifiedCheckoutOverviewPage />} />
      <Route path="details" element={<UnifiedCheckoutDetailsPage />} />
      <Route path="pay" element={<UnifiedCheckoutPayPage />} />
      <Route path="success" element={<UnifiedCheckoutSuccessPage />} />
    </Route>
  </Route>
);
